var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 9.41429L3.70718 13.7072L2.29297 12.293L6.58586 8.00008L2.29297 3.70718L3.70718 2.29297L8.00008 6.58586L12.293 2.29297L13.7072 3.70718L9.41429 8.00008L13.7072 12.293L12.293 13.7072L8.00008 9.41429Z",
    fill: "#36393D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic-close.648ba53fe732b776792a48d2e7a697f4.svg";
export { ForwardRef as ReactComponent };